module.exports = __webpack_public_path__ + "static/media/m9sj.4a653dda.png";